/**
 * Lightweight event-based toast — no React context or Provider needed.
 * Works from any file: import { toast } from '../utils/toast';
 *
 * toast('message')                   → infers type from message (success green / failure red)
 * toast('message', 'success')        → green
 * toast('message', 'error')          → red
 * toast('message', 'warning')        → amber
 * toast('message', 'info')           → blue
 */

function inferToastType(message) {
  const lower = String(message).trim().toLowerCase();
  if (!lower) return 'error';

  if (
    /^(failed|fail\b|error\b|could not|unable to|unable |invalid|denied|forbidden|not found|expired)/.test(lower)
    || /\bfailed\b|\berror\b|\bdenied\b|\bforbidden\b|\baction failed\b/.test(lower)
  ) {
    return 'error';
  }

  if (/\bwarn\b|caution\b|please select|please enter|is required\b|are required\b/.test(lower)) {
    return 'warning';
  }

  if (
    /\bsuccessfully\b|\bupdated\b|\bcreated\b|\bdeleted\b|\bsaved\b|\badded\b|\bremoved\b|\bsent\b|\bsubmitted\b|\bcomplete\b|\bthank you\b/.test(lower)
  ) {
    return 'success';
  }

  return 'error';
}

export function toast(message, type) {
  const resolvedType = type ?? inferToastType(message);
  window.dispatchEvent(
    new CustomEvent('app:toast', {
      detail: {
        message: String(message),
        type: resolvedType,
        id: Date.now() + Math.random(),
      },
    })
  );
}
